import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormRow, Checkbox } from '@here/ref-client-ui';
import CustomToggleButton from 'shared/toggleButton';
import './tollsContainer.scss';
import chroma from "chroma-js";

export default class RoRForm extends Component {
  getTollSystems () {
    const { route, onTollSystemsCheckboxChange, showTollroad, colorPalette, tollSystemsRoadExclude } = this.props;
    const tollSystemsList = [];
    const tollRouteSystems = [];
    const excludes = tollSystemsRoadExclude.split(',');
    route.sections.forEach(section => {
      const { tollSystems = [], spans = [] } = section;
      tollSystemsList.push(...tollSystems.filter(tollSystem =>
        !tollSystemsList.some(thisTollSystem => thisTollSystem.name === tollSystem.name && thisTollSystem.id === tollSystem.id)
      ));

      spans.forEach(span => {
        const tollSystemsSpan = span.tollSystems;
        if (tollSystemsSpan) {
          const idx = tollSystemsSpan.map(i => {
            const tollSystem = tollSystems[i];
            return tollSystemsList.findIndex(thisTollSystem => thisTollSystem.name === tollSystem.name && thisTollSystem.id === tollSystem.id )
          }).join(':');
          if (!tollRouteSystems.includes(idx)) {
            tollRouteSystems.push(idx);
          }
        }
      })
    })

    const colorScale = chroma.scale([colorPalette.primary, 'black']).mode('lch').colors(tollSystemsList.length+2);

    return (
      tollRouteSystems.map((tollRouteSystem, idx) => {
        const names = tollRouteSystem.split(':').map(id => tollSystemsList[id].name).sort();
        return (<FormRow 
          key={'tollSystem'+idx}
          className={'rf-form-tollSystemName'}
        >
          <Checkbox
            style={{ backgroundColor: colorScale[idx+1] }}
            disabled={!showTollroad}
            label={names.join(', ')}
            isChecked={!excludes.includes(names.join('-'))}
            onChange={onTollSystemsCheckboxChange.bind(this, 'tollSystemsRoadExclude', names.join('-'))}
        /></FormRow>)
      })
    )
  }

  render() {
    const { onCheckboxChange, isActive, showTollbooth, showTollroad, showTollboothName, onToggle } = this.props;

    return (
      <div className="rf-map__tooltip rf-map__toll-module rf-map__toll-module_elements">
        <h2>Tolls Route</h2>
        <FormRow>
          <CustomToggleButton checked={isActive} onChange={onToggle} />
        </FormRow>

        <FormRow className="rf-map-tollbooth">
          <Checkbox
            label="Show tollbooth"
            isChecked={showTollbooth}
            onChange={onCheckboxChange.bind(this, 'showTollbooth')}
          />
          <h2>Name</h2>
          <CustomToggleButton 
            checked={showTollboothName} 
            disabled={!showTollbooth}
            onChange={onCheckboxChange.bind(this, 'showTollboothName')}
          />
        </FormRow>
        <FormRow>
          <Checkbox
            label="Show toll road"
            isChecked={showTollroad}
            onChange={onCheckboxChange.bind(this, 'showTollroad')}
          />
        </FormRow>
        {this.getTollSystems()}
      </div>
    );
  }
}

RoRForm.propTypes = {
  onCheckboxChange: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  isActive: PropTypes.bool.isRequired,
  rangeOnRoute: PropTypes.object.isRequired,
};
